import $ from 'jquery';

var staticDuration = 8000;
var fadeDuration = 2000;

function init() {
    if ($('.banner').data('static') != undefined) {
        staticDuration = $('.banner').data('static');
    }
    if ($('.banner').data('fade') != undefined) {
        fadeDuration = $('.banner').data('fade');
    }
}

function fadeOutImage(image) {
    return new Promise(function (resolve, reject) {
        $(image)
            .delay(staticDuration)
            .animate({ opacity: 0 }, fadeDuration, function () {
                $(image).hide();
                resolve('done');
            });
    });
}
function fadeImage(image) {
    return new Promise(function (resolve, reject) {
        $(image)
            .show()
            .animate({ opacity: 1 }, fadeDuration, function () {
                fadeOutImage(image).then(function () {
                    resolve('done');
                });
            });
    });
}

function changeBanner(index) {
    var isFirstElement = index == 0;
    var isLastElement = index == $('.banner__image').length - 1;
    var image = $('.banner__image').eq(index);

    if (isFirstElement) {
        if ($(image).is(':hidden')) {
            fadeImage(image).then(function () {
                changeBanner((index += 1));
            });
        } else {
            fadeOutImage(image).then(function () {
                changeBanner((index += 1));
            });
        }
    } else if (isLastElement) {
        fadeImage(image).then(function () {
            changeBanner(0);
        });
    } else {
        fadeImage(image).then(function () {
            changeBanner((index += 1));
        });
    }
}

$(function () {
    if ($('.banner').length) {
        init();
        if ($('.banner__image').length > 1) {
            changeBanner(0);
        }
    }
});
